import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1044',
    ecrans: ['00-2'],
    params: ['id', 'unacleint']
});
